<template>
  <div class="card">
    <h5 class="card-header">
      <span class="badge bg-success rounded-pill bx-pull-right font-size-12">
        Mes actual
      </span>
      Ingresos
    </h5>
    <div class="card-body">
      <div class="d-flex align-items-center">
        <div class="flex-shrink-0 me-3">
          <div class="avatar">
            <div class="avatar-title rounded bg-success bg-gradient">
              <eva-icon
                name="pie-chart-2"
                class="fill-white"
              ></eva-icon>
            </div>
          </div>
        </div>
        <div class="flex-grow-1">
          <p class="text-muted mb-1">Total de ingresos</p>
          <h4 class="mb-0">{{ formatoMoneda(total) }}</h4>
        </div>
        <div class="flex-shrink-0 align-self-end ms-2">
          <div class="badge rounded-pill font-size-13 badge-soft-success">
            {{ porcentaje }}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Componente de Ingresos del mes
 */
var accounting = require('accounting/accounting.js')
import AbonoSrv from '@/services/AbonoSrv.js'
export default {
  name: 'CmpIngresosMes',
  data() {
    return {
      total: 0,
      totalFacturasPendientesPago: 0,
      porcentaje: 100,
      intervals: {
        actualizacion: null
      }
    }
  },
  computed: {
    monedaSistema:function(){
      return this.$store.state.todo.moneda_sistema
    }
  },
  created: function() {
    var self = this
    self.refrescarTotal()
    // Actualización periódica del total
    self.intervals.actualizacion = setInterval(function() {
      self.refrescarTotal()
    }, 120000)
    iu.bus.on('total-facturas-pendientes-pago-cargadas', function(
      totalFacturasPendientesPago
    ) {
      self.totalFacturasPendientesPago = totalFacturasPendientesPago
      self.actualizarPorcentaje()
    })
  },
  beforeUnmount: function() {
    clearInterval(this.intervals.actualizacion)
  },
  methods: {
    actualizarPorcentaje: function(totalFacturasPendientesPago) {
      this.porcentaje = Math.round(
        (parseFloat(this.total) /
          (parseFloat(this.total) +
            parseFloat(this.totalFacturasPendientesPago))) *
          100
      )
    },
    formatoMoneda: function(numero) {
      return accounting.formatMoney(numero, { symbol: this.monedaSistema.simbolo, miles: ",", decimal: "." })+' '+this.monedaSistema.codigo
    },
    refrescarTotal: function() {
      var self = this

      AbonoSrv.totalIngresosMes().then(response => {
        let total = response.data
        self.total = total
        iu.bus.emit('total-ingresos-mes', total)
        self.actualizarPorcentaje()
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo obtener el total de ingresos del mes'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
</style>